import { FuncionalidadesGeral } from '../../../helpers/funcionalidades'
import relatorioIcon from '../../../images/icones-os034/relatorio-estatistico.png'

/**
 * HU-023 — o card da página inicial e o item de menu do Relatório Estatístico.
 *
 * <p>O texto e a categoria são os do Figma da história (frame "Relatório Estatístico / Informe
 * o período").</p>
 *
 * <p>A rota é um marcador, não um destino: acionar o card abre o modal de período (CA19), e o
 * relatório só é gerado depois do "Confirmar". Quem reconhece esse marcador e abre o modal é a
 * página inicial e o Layout.</p>
 */
export const ACAO_RELATORIO_ESTATISTICO = '#relatorio-estatistico'

/**
 * Caminho do item de menu. O menu lateral navega de verdade, então ele leva para a página
 * inicial com o marcador na query — é ela que abre o modal de período.
 */
export const ROTA_ABRIR_RELATORIO_ESTATISTICO = '/?acao=relatorio-estatistico'

export const options = [
  {
    title: 'Relatório Estatístico de Comunicações',
    icon: relatorioIcon,
    description: 'Emita relatório com estatísticas referentes às comunicações.',
    route: ACAO_RELATORIO_ESTATISTICO,
    order: 1,
    area: 'relatorios',
    funcionalidade: FuncionalidadesGeral.relatorios.estatisticoComunicacao,
  },
]
